export class NewDocumentTemplate {
  public name: string;
}

export class DocumentTemplate extends NewDocumentTemplate {
  public id?: number;
}
